export default __webpack_public_path__ + "static/media/curtain.7e040f70.svg";